import { getExpenseLabel } from "web_myplann/Finances/Helpers/getExpenseLabel";
import type { FinanceState } from "web_myplann/Finances/State/FinanceAtom";
import type { FinanceChartDataPoint } from "web_myplann/Finances/Types/FinanceChartDataPoint";
import type { TranslateFunction } from "web_myplann/Shared/TranslateFunction";

export const mapExpenseToChartData = (
	expense: FinanceState["expenses"][number],
	t: TranslateFunction,
): FinanceChartDataPoint => ({
	value: expense.monthlyPayment,
	label: getExpenseLabel(expense, t),
});
